import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";

import { appendSearchParamsToQuery } from "../../../ComplianceSearch/utils";
import usePagination from "../../../../hooks/usePagination";
import { COMPLIANCE_API_URLS, ComplianceAPI } from "../../../../api/compliance";
import { fundedComplianceProfileActions } from "../../../../reducers/fundedComplianceProfile";
import { TCP_STEPS_COLUMNS } from "../../../ComplianceSearch/constants";
import Table from "../../../../components/ui/Table";

const TCPsteps: React.FC = () => {
  const dispatch = useDispatch();
  const params: { id: string } = useParams();
  const search = { compliance_entries_id: params.id };
  const pagination = usePagination(10);
  const { data: results, isLoading } = useSelector(
    (state) => state.fundedComplianceProfile.tcpSteps
  );

  const { isError, error } = useQuery({
    queryKey: [COMPLIANCE_API_URLS.getTCPSteps, params.id, pagination.page, pagination.limit],
    async queryFn({ signal }) {
      const query = new URLSearchParams();
      query.append("limit", pagination.limit.toString());
      query.append("page", pagination.page.toString());
      appendSearchParamsToQuery(search, query);

      dispatch(fundedComplianceProfileActions.fetchTCPstepsRequest());
      const response = await ComplianceAPI.getTCPStepsRequest(query.toString(), signal);
      pagination.setCount(response.data.results.count);

      dispatch(fundedComplianceProfileActions.fetchTCPstepsSuccess(response.data.results));

      return response;
    },
  });

  useEffect(() => {
    if (isError && error) {
      console.error("Error fetching TCP steps", error);
      dispatch(fundedComplianceProfileActions.fetchTCPstepsFailed());
    }
  }, [isError, error]);

  return (
    <Table
      columns={TCP_STEPS_COLUMNS}
      data={results.rows}
      loading={isLoading}
      pagination={pagination}
      extractKey={(row) => row.id}
      theadTitle="TCP Steps "
      csv_table_name={`TCP Steps entry ID: ${params.id}`}
      noResultsMessage="There are no TCP Steps records"
    />
  );
};

export default TCPsteps;
